module.exports = __webpack_public_path__ + "img/policy-scope-history.ecb0518d.png";